<template>
  <div>
      <div class="col-md-12">
        <boton-atras :nombre_ruta="'Menu'"/>
      </div>
      <h1 class="titulo-uno">Presupuesto de Egresos por Organismo Público</h1>
      <div>
          <div v-for="(apartado, a) in dataPresupEgreOp" :key="a">
            <h5>{{apartado.titulo}}</h5>
            <!-- {{apartado}} -->
            <div v-for="(seccion, s) in apartado.secciones" :key="s">
              <div v-if="seccion.titulo_seccion != ''">
                <h6 class="ml-3">{{seccion.titulo_seccion}}</h6>
              </div>
              <!-- {{seccion}} -->
              <div v-for="(archivo, ar) in seccion.archivos_seccion" :key="ar">
                  <ul>
                    <li>
                        <!-- <a :href="urlServe + archivo.url_pdf" target="_blank">{{ apartado.titulo }}</a> -->
                        <a v-if="archivo.url_excel!=''" :href="urlServe+archivo.url_excel" target="_blank" class="">{{archivo.titulo}} <i class="fas fa-file-excel m-1 text-success"></i></a>
                        <a v-if="archivo.url_pdf!=''" :href="urlServe+archivo.url_pdf" target="_blank" class="">{{archivo.titulo}} <i class="fas fa-file-pdf m-1 text-danger"></i></a>
                      </li>
                  </ul>
              </div>
            </div>
          </div>
      </div>
  </div>
</template>
<script>
import mapFun from '@/common/map-fn-types.js';
import RendicionDeCuentas from "@/services/rendicionDeCuentas/rendicionDeCuentas.js";
const _serviciosRendicionC = new RendicionDeCuentas();
import botonAtras from '../../button-atras.vue';

export default {
  components: {botonAtras},
  created(){
    window.scrollTo(0, 0);
    this.getPresupuestoEgresosOP()
  },
  data(){
    return{
      dataPresupEgreOp: []
    }
  },
  methods:{
    async getPresupuestoEgresosOP() {
      try {
          const response = await _serviciosRendicionC.getPresupuestoEgresosOP(mapFun.presupuestoEgresosOP);
          this.dataPresupEgreOp = response.data;

      } catch (error) {
          console.log('error', error.message);
      }
    }
  }
}
</script>
<style scoped>
a{color: #212529;}
a:hover{color: #212529;}
</style>
